'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var useLocalStorage = require('./useLocalStorage.js');
var useRemoteData = require('./useRemoteData.js');

var index = { useRemoteData: useRemoteData["default"], useLocalStorage: useLocalStorage.useLocalStorage };

exports["default"] = index;
